import React from 'react';
import './ProjectCard.css'
import EventFairy from '../../images/EventFairy.jpg'
import { Card, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const ProjectCard = (props) => {
    const { name, image, description, liveURL, clientCodeURL, serverCodeURL } = props.project;
    return (
        <Card style={{ width: '405px' }} className='project-card m-3'>
            <Card.Img variant="top" className='project-img' src={image} />
            <Card.Body>
                <div className="d-flex">
                    <Card.Title>{name}</Card.Title>
                    <div className='ml-5'>
                        <Link target='_blank' to={"//" + liveURL} > <FontAwesomeIcon className='m-1' style={{ fontSize: '20px' }} icon={faExternalLinkAlt} /></Link>

                        <Link target='_blank' to={"//" + clientCodeURL} > <FontAwesomeIcon title='Client Side Code' className='m-1' style={{ fontSize: '20px' }} icon={faGithub} /></Link>

                        {serverCodeURL && <Link target='_blank' to={"//" + serverCodeURL} > <FontAwesomeIcon title='Server Side Code' className='m-1' style={{ fontSize: '20px' }} icon={faGithub} /></Link>}

                    </div>
                </div>

                <Card.Text>{description}</Card.Text>
                <Badge variant="secondary m-1">React.js</Badge>
                <Badge variant="secondary m-1">Bootstrap</Badge>
                {name !== "Club Mania" && <Badge Badge variant="secondary m-1">Firebase</Badge>}

                {
                    serverCodeURL && <>
                        <Badge variant="secondary m-1">Node.js</Badge>
                        <Badge variant="secondary m-1">Express.js</Badge>
                        <Badge variant="secondary m-1">MongoDB</Badge>
                    </>
                }
                {name === "Event Fairy" && <Badge variant="secondary m-1">Stripe.js</Badge>}



                <br />
     



            </Card.Body>
        </Card>
    );
};

export default ProjectCard;